<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>资料管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-width="60px"
        label-position="right"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="分类" label-width="80px" style="margin-left:-15px;">
          <el-cascader
            v-model="query.cateid"
            :options="catelist"
            :props="{emitPath:false,value:'id',label:'name',checkStrictly: true}"
            clearable
            @change="getList"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick();">搜索</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>资料列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column label="标题">
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
            </template>
          </el-table-column>
          <el-table-column label="分类">
            <template slot-scope="scope">
              {{scope.row.cateName1}}  {{scope.row.cateName2}}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cateName" label="分类"></el-table-column> -->
          <el-table-column prop="viewCount" label="浏览次数"></el-table-column>
          <el-table-column prop="downCount" label="下载次数"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog
      :title="form.id>0?'编辑资料':'添加资料'"
      :visible.sync="dialogVisible"
      @opened="dialogOpened()"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-form-item prop="title" label="标题" :rules="[{required:true,message:'不能为空'},{max:30,min:1,message:'最长30个字'}]">
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>

        <el-form-item label="文件附件" :rules="[{required:true,message:'不能为空'}]">
          <div id="uploadBtn13" class="uploader uploader-warning"></div>
          <span id="relativeName" style="margin-left:20px;">{{form.fileUrl}}</span>
          <span
            class="imgtext"
            title
            type="info"
            style="position:relative;left:0px;top:1px;"
          >*文件格式：pdf ; doc ; docx ; rar</span>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="cateID" label="资料分类" :rules="[{required:true,message:'不能为空'}]">
              <el-cascader
                v-model="form.cateID"
                :options="catelist"
                :props="{emitPath:false,value:'id',label:'name'}"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="summary" label="资料简介" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="textarea" v-model="form.summary" placeholder="请输入简介"></el-input>
        </el-form-item>

        <el-form-item prop="content" label="资料内容:" :rules="[{required:true,message:'不能为空'}]">
          <div style="position:relative;">
            <vue-ueditor-wrap v-model="form.content" :config="editorConfig"></vue-ueditor-wrap>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">确定</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import url from "@/plugins/urlHelper.js";
import "../../../public/lib/cover/Cover3.0.min.css";
import "../../../public/lib/cover/Cover3.0.min.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {
        cateid: ""
      },
      form: {},
      dialogVisible: false,
      submiting: false,
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      content: "",
      editorConfig: {
        zIndex: 3000, //配置控件组件弹出层
        initialFrameHeight: 300, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE()
      },
      catelist: []
    };
  },
  methods: {
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 分类
    getCateList: function() {
      var _this = this;
      var link = url.getVideo("getcate_datum");
      $.get(link, {}, data => {
        _this.catelist = data;
      });
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getVideo("getlist_datum");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selClick: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      var _this = this;
      _this.dialogVisible = true;
      var id = row.id;
      var link = url.getVideo("getmodel_datum");
      $.get(link, { id: id }, data => {
        _this.form = data;
      });
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getVideo("delete_datum");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 上传
    dialogOpened: function() {
      var _this = this;
      if ($("#uploadBtn13 input").length == 0) {
        $("#uploadBtn13").uploader({
          url: url.getUpload(),
          text: "上传文件",
          fileExts: "pdf;doc;docx;rar",
          handleType: "0",
          debug: false,
          maxSize: 1024 * 1024 * 10, //上传文件最大值
          //开始上传验证扩展
          onSuccess: function(data) {
            var relativeName1 = data.relativeName; //解决其他js时间中的vue数据同步问题
            _this.$set(_this.form, "fileUrl", relativeName1);
          }
        });
      }
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getVideo("save_datum");
      var info = this.form;

      if (this.form.fileUrl == undefined) {
        _this.$message({
          type: "error",
          message: "请选择文件"
        });
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          _this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  components: {
    VueUeditorWrap
  },
  mounted() {
    // 分类
    this.getCateList();
    // 列表
    this.getList();
  }
};
</script>